import { useSelector } from 'react-redux';
import _ from 'lodash';
import InputForm from '../InputForm';
import { RootState } from '../../../../../../../state/store';
import formKeyPlAssumptionsTemplate from './formKeyPlAssumptionsTemplate.json';
import { getRowTemplate, getFormDataFromState, getForm } from '../../common/FormUtil';
import { FormGroup, FinanceFormType, FormGroupType, FormGroupI } from '../../../../../../../types/inputform.d';

export const generateFormKeyPlAssumptionsCells = (
  group: FormGroupType,
  keyPlAssumptionsCells: any,
  dbJson: any,
  loanDetails: any
) => {
  const formCells = _.cloneDeep(keyPlAssumptionsCells);

  let allRows: any[] = [];
  let formDataCells: any;

  if (!_.isEmpty(formCells)) {
    formDataCells = getFormDataFromState(formCells, group);
  } else if (_.isEmpty(formCells)) {
    const formKeyPlAssumptions = _.cloneDeep(formKeyPlAssumptionsTemplate) as any;

    // Total Rows //
    allRows = getRowTemplate('label', formKeyPlAssumptions);

    formDataCells = getForm(
      formCells,
      FinanceFormType[FinanceFormType.FORMKEYPLASSUMPTIONS].toLowerCase(),
      group,
      allRows,
      dbJson,
      loanDetails
    );
  }
  console.log(formDataCells);

  // if (group === FormGroup.PROJECTION) {
  //   Object.entries(formJson).map(([, cell]) => cell?.expr && cellUpdate(copyCells, cell, cell?.expr));
  // }
  return formDataCells;
};

export const FormKeyPlAssumptions = ({ group }: FormGroupI) => {
  const cells = useSelector(
    (state: RootState) =>
      state?.financeInputscreen?.cells![FinanceFormType[FinanceFormType.FORMKEYPLASSUMPTIONS].toLowerCase()]
  );

  if (!group || !cells) return <></>;

  const cellData: any = {};

  const actualsCells = Object.fromEntries(
    Object.entries(cells).filter(([, value]: any) => value?.group === FormGroup[FormGroup.ACTUALS].toLowerCase())
  );
  _.merge(cellData, actualsCells);

  if (group === FormGroup.PROJECTION) {
    const projectionCells = Object.fromEntries(
      Object.entries(cells).filter(
        ([, value]: any) => value?.group === FormGroup[FormGroup.PROJECTION].toLowerCase()
      )
    );
    _.merge(cellData, projectionCells);
  }

  return <InputForm cells={cellData} />;
};
